<script>
    import { checkSession_getSelf, apiRequest, communicationError, apiResponseBody, logout } from "../lib/api";
    import { normalize } from "../lib/display";
    import { privileges } from "../lib/translations.json"
    import { onMount } from "svelte";

    /** @import {User, Session} from "../lib/api" */

    /** @type {User} */
    let user = $state();
    /** @type {Session} */
    let session = $state();

    
    /** @type {Promise<Object.<string, string>>} */
    let groups = $state({});
    let groupInputName = $state("");
    let groupInputId = $derived(normalize(groupInputName));

    /** @type {Promise<Object.<str, User>} */
    let users = $state({});
    /** @type {User} */
    let userInput = $state({});
    /** @type {string?} */
    let userId = $state();
    let userCmdStr = $state("Créer");

    /** @type {HTMLDialogElement} */
    let createUserDialog = $state();
    /** @type {HTMLDialogElement} */
    let groupsDialog = $state();

    async function fetchUsers() {
        const resp = await apiRequest(session, "users.admin.list", {});
        if (!resp.ok) communicationError("Erreurs lors chargement des utilisateurs");
        users = await apiResponseBody(session, resp);
    }

    async function submitUser() {
        if (userId) {
            const resp = await apiRequest(session, "users.admin.modify", {id: userId, user: userInput});
            if (!resp.ok) communicationError("Erreur modification utilisateur");
        } else {
            const resp = await apiRequest(session, "users.admin.create", userInput);
            if (!resp.ok) communicationError("Erreur creation utilisateur");
        }

        fetchUsers();
        createUserDialog.close();
    }

    /** @param {string} id  */
    async function removeUser(id) {
        if (!confirm(`Supprimer l'utilisateur ${users[id].name} ?`)) return;
        const resp = await apiRequest(session, "users.admin.remove", {id: id});
        if (!resp.ok) communicationError("Erreur suppression utilisateur");
        fetchUsers();
    }



    async function fetchGroups() {
        const resp = await apiRequest(session, "users.groups.list", {});
        if (!resp.ok) communicationError("Erreurs lors chargement des groupes");
        groups = await apiResponseBody(session, resp);
    }

    async function addGroup() {
        const resp = await apiRequest(session, "users.groups.add", {
            id: groupInputId,
            name: groupInputName
        });
        if (!resp.ok) communicationError("Erreur lors de l'ajout du groupe");
        fetchGroups();
        groupInputName = "";
    }

    /** @param {string} id @param {string} name   */
    async function removeGroup(id, name) {
        if (!confirm(`Supprimer le groupe ${name} ?`)) return;
        const resp = await apiRequest(session, "users.groups.remove", {
            id: id,
        });
        if (!resp.ok) communicationError("Erreur lors de la suppression du groupe");
        fetchGroups();
    }

    onMount(async ()=>{
        ({session: session, user: user} = await checkSession_getSelf());
        if (! user.privileges.includes("admin")) logout();
        fetchGroups();
        fetchUsers();
    });
</script>

<header>
    <a href="/home" id="home-button">
        <img class="icon" src="/www/favicon.png" alt="Letas Icon" />
        <span>{user?.name ?? ""}</span>
    </a>
    <div style="flex-grow: 1;"></div>
</header>

<section id="tool-bar">
    <button onclick={() => {
        userCmdStr = "Créer";
        userInput = {};
        userId = undefined;
        createUserDialog.showModal();
    }}>  </button>
    <button onclick={()=>{groupsDialog.showModal()}}>  </button>
</section>

<div class="masonry-layout">
    {#each Object.entries(users).sort((a,b)=>a[1].name.localeCompare(b[1].name)) as [id, user]}
        <div class="user box gradient">
            <div style="width: 100%;">
                <b style="font-size: 150%; float: left;"> {user.name} </b>
                <span style="float: right;">Code : {user.code} </span>
            </div>
            {#if user.groups.length > 2} 
                <div> <b>Groupes :</b> </div>
                <div class="dark-bg"> {user.groups.filter(g=>g != "public" && g != id).map(g=>groups[g]).join(", ")} </div>
            {/if}
            {#if user.privileges.length} 
                <div>
                    <b>Privilèges :</b>
                    <ul class="dark-bg">
                        {#each user.privileges as privilege}
                            <li tabindex="-1" title="{privileges[privilege].description}" style="font-weight: bold; color: var(--gold);">
                               {privileges[privilege].name} 
                            </li>
                        {/each}
                    </ul>
                </div>
            {/if}
            <div style="flex-grow: 1;"></div>
            <div style="margin-top: .5em;">
                <button class="dark-button" onclick={()=>{
                    userId = id;
                    userCmdStr = "Modifier";
                    userInput = JSON.parse(JSON.stringify(user));
                    userInput.groups = userInput.groups.filter(g => g != id && g != "public")
                    createUserDialog.showModal();
                }}>Modifier &thinsp;󰚼</button>
                <button class="dark-button" onclick={()=>{removeUser(id)}}>Supprimer &thinsp;󱋟</button>
            </div>
        </div>
    {/each}
</div>


<dialog bind:this={createUserDialog} id="user-create-dialog" class="gradient" closedby="any">
    <h1>{userCmdStr} un Utilisateur</h1>
    <form id="user-form" onsubmit={e=>{e.preventDefault(); submitUser()}}>
        <div >
            <input
                type="text"
                bind:value={userInput.name}
                required
                maxlength="30"
                placeholder="Nom"
                style="margin: .5em;"
            />
            <input
                type="text"
                bind:value={userInput.code}
                required
                maxlength="20"
                placeholder="Code"
                style="margin: .5em;"
            />
        </div>
        <select
            style="display: block; align-self: center;"
            onchange={e=>{if (!userInput.privileges) userInput.privileges = []; userInput.privileges.push(e.target.value); e.target.value = ""}}
        >
            <option value="" disabled selected>Ajouter un Privilège</option>
            {#each Object.entries(privileges).filter(p => ! userInput.privileges?.includes(p[0])) as [priv_id, priv_obj] }
                <option value={priv_id}>{priv_obj.name}</option>
            {/each}
        </select>
        {#if userInput.privileges?.length} <ul class="dark-bg multi-select">
            {#each userInput.privileges as pid, index }
                <li  style="color: var(--gold); font-weight: bold;">
                    <button onclick={e=>{e.preventDefault(); userInput.privileges.splice(index, 1)}}></button>
                    <span tabindex="-1" title="{privileges[pid].description}">{privileges[pid].name}</span>
                </li>
            {/each}
        </ul> {/if}
        <select
            style="display: block; align-self: center;"
            onchange={e=>{if (!userInput.groups) userInput.groups = []; userInput.groups.push(e.target.value); e.target.value = ""}}
        >
            <option value="" disabled selected>Ajouter un Groupe</option>
            {#each Object.entries(groups).filter(g => ! userInput.groups?.includes(g[0])) as [group_id, group_name] }
                <option type="button" value={group_id}>{group_name}</option>
            {/each}
        </select>
        {#if userInput.groups?.length} <ul class="dark-bg multi-select">
            {#each userInput.groups as gid, index }
                <li style="font-weight: bold;">
                    <button type="button" onclick={e=>{e.preventDefault(); userInput.groups.splice(index, 1)}}></button>
                    {groups[gid]}
                </li>
            {/each}
        </ul> {/if}
    </form>
    <button class="dark-button" type="submit" form="user-form">{userCmdStr} &thinsp;</button>
    <button class="dark-button" command="close" commandfor="user-create-dialog">Fermer </button>
</dialog>

<dialog bind:this={groupsDialog} id="groups-dialog" class="gradient" closedby="any">
    <h1>Groupes</h1>
    <form onsubmit={e=>{e.preventDefault(); addGroup();}}>
        <div style="display: flex;">
            <input
                type="text"
                bind:value={groupInputName}
                required
                maxlength="20"
                pattern="[0-9A-zÀ-ú _-]*"
                placeholder="Ajouter un Groupe"
            />
            <button class="dark-button" style="margin-left: 1em;" type="submit"></button> <br/>
        </div>
        <div style="text-align: left;"> {#if groupInputId} ID Groupe : {groupInputId} {/if} </div>
    </form>
    <ul class="dark-bg multi-select">
        {#each Object.entries(groups) as [id, name]}
            <li>
                <button onclick={()=>{removeGroup(id, name)}}></button>
                {name} 
            </li>
        {/each}
    </ul>
    <button autofocus class="dark-button" command="close" commandfor="groups-dialog">Fermer &thinsp;</button>
</dialog>

<style>
/* ul { */
/*     max-height: 20lh; */
/*     overflow: scroll; */
/*     margin: 0; */
/* } */
/* li { */
/*     list-style: none; */
/*     margin: .5em auto; */
/* } */
/* li button { */
/*     float: right; */
/* } */

form select {
    margin: 0.5em auto;
}

.user {
    display: flex;
    flex-direction: column;
    align-items: center;
}
</style>

